module.exports = __webpack_public_path__ + "img/Pham.e643bc7e.jpg";